function createComment() {
    $(document).on("submit", '.form_comment', function (e) {
        var form_comment = $(this);

        if (form_comment.length > 0) {
            var comment_content = $(form_comment).find('[name=content]').val().trim();
            var comment_email = $(form_comment).find('[name=email]').val().trim();
            var comment_name = $(form_comment).find('[name=name]').val().trim();

            if (comment_content.length < 3) {
                $(form_comment).find('.comment_error').text('Bạn chưa nhập bình luận hoặc bình luận của bạn quá ngắn').show();

            } else if (comment_name === "") {
                $(form_comment).find('.block_comment_info').show();
                $(form_comment).find('.comment_error').text('Vui lòng nhập tên của bạn').show();

            } else if (comment_email === "") {
                $(form_comment).find('.block_comment_info').show();
                $(form_comment).find('.comment_error').text('Vui lòng nhập địa chỉ email hợp lệ').show();

            } else {
                $(form_comment).find('.block_comment_info').hide();
                $(form_comment).find('.comment_error').text('').hide();

                $.ajax({
                    type: "post",
                    url: $(form_comment).attr('action'),
                    dataType: 'json',
                    data: $(form_comment).serialize(),
                    beforeSend: function () {
                        $('[type=text],textarea, button[type=submit]', $(form_comment)).attr('disabled', true).css({'opacity': '0.5'});
                    },
                    success: function (res) {
                        $('[type=text],textarea, select, button[type=submit]', $(form_comment)).attr('disabled', false).css({'opacity': 1});

                        $('button[type=submit]').attr('disabled', false);

                        $(form_comment)[0].reset();

                        if (res.status === 'success') {

                            let user_info = {
                                email: comment_email,
                                name: comment_name
                            };

                            localStorage.setItem('user_info', JSON.stringify(user_info));

                            var parent_id =  $(form_comment).find('input[name=parent_id]').val();

                            console.log(parent_id);

                            if(parent_id > 0){
                                $(form_comment).closest('.block_comment').remove();
                            }

                            swal({
                                "title": "Thành công",
                                "html": "<p style='color: #000;'>" + res.message + "</p>",
                                "type": "success"
                            });
                        } else {
                            swal({
                                "title": "Lỗi",
                                "html": res.message,
                                "type": "error",
                                "confirmButtonColor": "red"
                            });
                        }
                    }
                });
            }


            return false;
        }

        e.preventDefault();
    });

}

function loadUserInfo() {
    var user_info = localStorage.getItem('user_info');

    if (user_info !== null) {
        user_info = JSON.parse(user_info);

        console.log(user_info);

        var form_comment = $('.form_comment');
        $(form_comment).find('[name=email]').val(user_info.email);
        $(form_comment).find('[name=name]').val(user_info.name);
    }
}

function replyComment() {
    $(document).on('click', '.btn_reply_comment', function () {

        var block__comment = $(this).closest('.block__comment');

        var form_comment = $('.main_form_comment').clone();

        var parent_id = $(block__comment).find('input[name=parent_id]').val();

        form_comment = form_comment.removeClass('main_form_comment');

        form_comment.find('input[name=parent_id]').val(parent_id);

        $(block__comment).append(form_comment);
    })
}

$(function () {
    loadUserInfo();

    createComment();

    replyComment();

    console.log('comment.js');
});



// WEBPACK FOOTER //
// ./resources/assets/js/comment.js